import Cookies from 'js-cookie';

const COOKIE_NAME = 'cookie_consent';
const COOKIE_DAYS = 1;

$(document).ready(function () {
    const $banner = $('#cookie-consent');
    const $btn = $('#cookie-consent-btn');

    if (Cookies.get(COOKIE_NAME)) {
        return;
    }

    $banner.addClass('is-visible');

    $btn.on('click', function () {
        Cookies.set(COOKIE_NAME, '1', { expires: COOKIE_DAYS });
        $banner.removeClass('is-visible');
    });
});
